"use strict";

function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
(function () {
  // THE SIMULATION ENGINE, PART 2 OF 3: the reducers (vitals, log, scenario, core state).
  var _React = React,
    useState = _React.useState,
    useEffect = _React.useEffect,
    useRef = _React.useRef,
    useReducer = _React.useReducer;
  var _window = window,
    INTERVENTIONS = _window.INTERVENTIONS,
    calculateDynamicVbg = _window.calculateDynamicVbg,
    getRandomInt = _window.getRandomInt,
    clamp = _window.clamp;

  // The single shared rhythm registry. Every shockability, pulseless and
  // "is this an arrest?" decision in this file now goes through RG. The previous hardcoded
  // arrays (two shockability lists, seven arrest lists) are gone.
  var RG = window.RHYTHMS;

  // RAISED ICP THERAPY. In a neuro scenario the modelled ICP answers to what the team does:
  // osmotherapy (hypertonic saline, mannitol) while its pk envelope is active; a tube with
  // normocapnia (ETCO2 4.0-5.0 kPa) stops the rise and brings a high ICP down slowly;
  // hypoventilation (ETCO2 above 6.0) makes it climb faster. Shared by the core tick and the
  // Cushing response so the two never disagree about whether the patient is being treated.
  var icpTherapy = function icpTherapy(cs, t) {
    if (!cs) return {
      osmo: 0,
      normocapnic: false,
      hypercapnic: false,
      treated: false
    };
    var osmo = (cs.activeDrugs || []).reduce(function (m, d) {
      return d && (d.key === 'HypertonicSaline' || d.key === 'Mannitol') ? Math.max(m, pkFactor(d, t)) : m;
    }, 0);
    var act = cs.activeInterventions;
    var tube = !!(act && typeof act.has === 'function' && act.has('RSI'));
    var et = cs.vitals ? Number(cs.vitals.etco2) : NaN;
    var normocapnic = tube && Number.isFinite(et) && et >= 4.0 && et <= 5.0;
    var hypercapnic = Number.isFinite(et) && et > 6.0 && !RG.inArrest(cs.rhythm);
    return {
      osmo: osmo,
      normocapnic: normocapnic,
      hypercapnic: hypercapnic,
      treated: osmo > 0 || normocapnic
    };
  };
  if (!RG) throw new Error('data/rhythms.js must load before data/engine.js');
  var _window$__EngineModel = window.__EngineModel,
    ARREST_SUPPRESSED = _window$__EngineModel.ARREST_SUPPRESSED,
    PULSELESS_RHYTHMS = _window$__EngineModel.PULSELESS_RHYTHMS,
    STANDARD_SENSOR_KEYS = _window$__EngineModel.STANDARD_SENSOR_KEYS,
    SYNC_OFFLINE_STATES = _window$__EngineModel.SYNC_OFFLINE_STATES,
    VENTILATOR_RATE = _window$__EngineModel.VENTILATOR_RATE,
    advanceTrendsOneSecond = _window$__EngineModel.advanceTrendsOneSecond,
    applyDeteriorationTick = _window$__EngineModel.applyDeteriorationTick,
    applyDriveTick = _window$__EngineModel.applyDriveTick,
    baseForDisplayed = _window$__EngineModel.baseForDisplayed,
    clampVital = _window$__EngineModel.clampVital,
    cleanDefibSettings = _window$__EngineModel.cleanDefibSettings,
    composeVitals = _window$__EngineModel.composeVitals,
    deteriorationTreatmentFactor = _window$__EngineModel.deteriorationTreatmentFactor,
    drivenVitals = _window$__EngineModel.drivenVitals,
    drugCeilings = _window$__EngineModel.drugCeilings,
    drugOffsets = _window$__EngineModel.drugOffsets,
    hasHighO2Consumption = _window$__EngineModel.hasHighO2Consumption,
    inferPotassium = _window$__EngineModel.inferPotassium,
    initialCoreState = _window$__EngineModel.initialCoreState,
    initialLogState = _window$__EngineModel.initialLogState,
    initialScenarioState = _window$__EngineModel.initialScenarioState,
    initialVitalsState = _window$__EngineModel.initialVitalsState,
    isCategoricalVital = _window$__EngineModel.isCategoricalVital,
    isDrugSpent = _window$__EngineModel.isDrugSpent,
    isVentilated = _window$__EngineModel.isVentilated,
    isVitalValueSafe = _window$__EngineModel.isVitalValueSafe,
    newRunId = _window$__EngineModel.newRunId,
    normaliseDeteriorationType = _window$__EngineModel.normaliseDeteriorationType,
    normalisePupils = _window$__EngineModel.normalisePupils,
    paralysisFromDrugs = _window$__EngineModel.paralysisFromDrugs,
    paralysisPhase = _window$__EngineModel.paralysisPhase,
    pkFactor = _window$__EngineModel.pkFactor,
    safeApnoeaSeconds = _window$__EngineModel.safeApnoeaSeconds,
    sanitizeForRealtimeDatabase = _window$__EngineModel.sanitizeForRealtimeDatabase,
    muteDrugsFor = _window$__EngineModel.muteDrugsFor;

  // ONE SECOND OF VENTILATOR PHYSIOLOGY (data/engine-vent.js), written into `base`.
  // SpO2, RR and ETCO2 are set to what the ventilator produces (in displayed space: the drug and
  // intervention envelope is taken off, so NIV/CPAP/BVM bonuses are not counted twice); HR and BP
  // get additive nudges that are removed again when the ventilator stops. A vital the facilitator
  // typed by hand (manualHold) is never touched. Mutates `base`; returns the new ventPhys.
  var VE = window.VENT_ENGINE;
  var ventTick = function ventTick(state, cs, base, t) {
    var prev = state.ventPhys;
    var driver = VE && cs ? VE.driverFor(cs) : null;
    var hold = state.manualHold || {};
    if (!driver) {
      if (!(prev && prev.active)) return {
        ventPhys: prev || null,
        changed: false,
        driving: false
      };
      // Stopped: take the HR/BP nudges off again (not in an arrest, which set new obs).
      var inArrest = cs ? RG.inArrest(cs.rhythm || 'Sinus Rhythm') : false;
      if (!inArrest) VE.NUDGED.forEach(function (k) {
        var a = prev.applied && prev.applied[k] || 0;
        if (a && Number.isFinite(base[k])) base[k] = clampVital(k, base[k] - a);
      });
      return {
        ventPhys: null,
        changed: true,
        driving: false
      };
    }
    var res = VE.step(prev, driver, cs, state.vitals);
    var offs = drugOffsets(cs.activeDrugs || [], t);
    VE.DRIVEN.forEach(function (k) {
      if (!hold[k]) base[k] = clampVital(k, res.targets[k] - (offs[k] || 0));
    });
    var applied = _objectSpread({}, res.ventPhys.applied || {});
    VE.NUDGED.forEach(function (k) {
      if (hold[k] || !Number.isFinite(base[k])) return;
      base[k] = clampVital(k, base[k] + (res.offsets[k] - (applied[k] || 0)));
      applied[k] = res.offsets[k];
    });
    return {
      ventPhys: _objectSpread(_objectSpread({}, res.ventPhys), {}, {
        applied: applied
      }),
      changed: true,
      driving: true
    };
  };

  // A Ventilator Sim scenario's starting lung adjustments (live.vent.lung), kept within the
  // facilitator's own slider ranges (e.g. CO2 production raised for malignant hyperthermia).
  var ventSimLung = function ventSimLung(l) {
    var VP = window.VENT_PROFILES,
      out = {};
    if (l && VP) Object.keys(l).forEach(function (k) {
      var d = VP.LUNG_ADJ[k],
        n = Number(l[k]);
      if (d && Number.isFinite(n)) out[k] = Math.min(d.max, Math.max(d.min, n));
    });
    return out;
  };
  var dropKey = function dropKey(obj, key) {
    var o = _objectSpread({}, obj || {});
    delete o[key];
    return o;
  };
  // Adds a ramp for `newTargets` (each from its value in `fromVitals`, over `duration` s) to the ramps
  // already running. Those keep their own start, target, length and progress; an obs named again
  // starts afresh. Older single-period trends (no `durations`) are carried over key by key.
  var mergeTrend = function mergeTrend(prev, newTargets, fromVitals, duration) {
    var dur = Number(duration);
    var targets = {},
      startVitals = {},
      durations = {},
      elapsedBy = {};
    if (prev && prev.active && prev.targets) {
      var legacy = !prev.durations;
      Object.keys(prev.targets).forEach(function (k) {
        if (Object.prototype.hasOwnProperty.call(newTargets, k)) return;
        targets[k] = prev.targets[k];
        startVitals[k] = (prev.startVitals || {})[k];
        durations[k] = legacy ? Number(prev.duration) : Number(prev.durations[k]);
        elapsedBy[k] = legacy ? Number(prev.elapsed) || 0 : Number((prev.elapsedBy || {})[k]) || 0;
      });
    }
    Object.keys(newTargets).forEach(function (k) {
      targets[k] = newTargets[k];
      startVitals[k] = (fromVitals || {})[k];
      durations[k] = dur;
      elapsedBy[k] = 0;
    });
    return {
      active: true,
      targets: targets,
      startVitals: startVitals,
      durations: durations,
      elapsedBy: elapsedBy,
      duration: dur,
      elapsed: 0
    };
  };
  var vitalsReducer = function vitalsReducer(state, action) {
    var cs = action.currentState;
    switch (action.type) {
      case 'CLEAR_SESSION':
        return _objectSpread({}, initialVitalsState);
      case 'LOAD_SCENARIO':
        if (!action.payload) return _objectSpread({}, initialVitalsState);
        var initialVitals = _objectSpread(_objectSpread({}, initialVitalsState.vitals), action.payload.vitals);
        // Give the scenario a clinically coherent starting K+ if it never declared one,
        // so hyperkalaemia scenarios actually start hyperkalaemic and the treatment has a
        // measurable endpoint. An explicit scenario/vitalsMod value always wins.
        // pH and K+ are what the VBG reports (window.liveVbg), so a patient whose scenario does
        // not state them starts with its own gas's pH, and its gas's K+ when that is abnormal
        // (otherwise the K+ inferred from the scenario, then the gas's).
        var sv = action.payload.vitals || {};
        var gas = action.payload.vbg || action.payload.investigations && action.payload.investigations.vbg || null;
        var gasPh = gas ? Number(gas.pH) : NaN,
          gasK = gas ? Number(gas.K) : NaN;
        if (sv.ph === undefined && Number.isFinite(gasPh)) initialVitals.ph = clampVital('ph', gasPh);
        if (sv.k === undefined) {
          var inferredK = inferPotassium(action.payload);
          var gasAbnormal = Number.isFinite(gasK) && (gasK < 3.5 || gasK > 5.3);
          if (gasAbnormal) initialVitals.k = clampVital('k', gasK);else if (inferredK !== null) initialVitals.k = inferredK;else if (Number.isFinite(gasK)) initialVitals.k = clampVital('k', gasK);
        }
        // A scenario that STARTS in cardiac arrest starts with arrest observations. The
        // built-in arrest scenarios only set hr/bp/SpO2/GCS, so the defaults filled in a
        // respiratory rate of 16 and normal pupils on a pulseless patient. Anything the
        // scenario states explicitly (its vitalsMod) still wins.
        var startRhythm = action.payload.ecg && action.payload.ecg.type || 'Sinus Rhythm';
        if (RG.isPulseless(startRhythm)) {
          var stated = action.payload.vitalsMod || {};
          var arrestObs = {
            bpSys: 0,
            bpDia: 0,
            spO2: 0,
            rr: 0,
            gcs: 3,
            pupils: 'Dilated',
            etco2: 1.5
          };
          Object.keys(arrestObs).forEach(function (k) {
            if (stated[k] === undefined) initialVitals[k] = arrestObs[k];
          });
        }
        return _objectSpread(_objectSpread({}, initialVitalsState), {}, {
          vitals: initialVitals,
          baseVitals: _objectSpread({}, initialVitals),
          prevVitals: _objectSpread({}, initialVitals)
        });
      case 'RESTORE_SESSION':
        {
          var restoredVitals = _objectSpread(_objectSpread({}, initialVitalsState.vitals), action.payload.vitals || {});
          return _objectSpread(_objectSpread({}, state), {}, {
            vitals: restoredVitals,
            baseVitals: _objectSpread(_objectSpread({}, restoredVitals), action.payload.baseVitals || {}),
            prevVitals: _objectSpread(_objectSpread({}, restoredVitals), action.payload.prevVitals || {}),
            trends: action.payload.trends || state.trends,
            hypoxiaTimer: action.payload.hypoxiaTimer || 0,
            hypoxiaDeficit: Number(action.payload.hypoxiaDeficit) || 0,
            manualHold: action.payload.manualHold || {},
            ventPhys: action.payload.ventPhys && _typeof(action.payload.ventPhys) === 'object' ? action.payload.ventPhys : null
          });
        }
      // The monitor does not run physiology; the authoritative composed vitals arrive over the
      // wire, so base == displayed there.
      case 'SYNC_FROM_MASTER':
        return _objectSpread(_objectSpread({}, state), {}, {
          vitals: action.payload.vitals || state.vitals,
          baseVitals: _objectSpread(_objectSpread({}, initialVitalsState.vitals), action.payload.vitals || {}),
          trends: action.payload.trends || state.trends
        });
      // UPDATE_VITALS writes the BASE (precedence step 1). Displayed vitals are recomposed with
      // the drug envelope so a facilitator/arrest/ROSC write can never silently delete an
      // in-flight drug effect, and a drug effect can never fight an explicit write.
      case 'UPDATE_VITALS':
        {
          var base = _objectSpread(_objectSpread({}, state.baseVitals), action.payload);
          var t = cs ? cs.time : 0;
          // A rhythm change writes its obs BEFORE the rhythm itself lands, so it says which
          // side of the arrest the new obs belong to (`forceArrest`); otherwise drug offsets
          // were composed onto arrest obs (HR 15, BP 40 in VF) until the next tick.
          var inArrest = typeof action.forceArrest === 'boolean' ? action.forceArrest : cs ? PULSELESS_RHYTHMS.indexOf(cs.rhythm) !== -1 : false;
          // Arrest, ROSC and pulseless<->organised transitions define a NEW
          // baseline, so they explicitly release the manual hold on the vitals they rewrite.
          var hold = state.manualHold || {};
          if (Array.isArray(action.releaseManual) && action.releaseManual.length) {
            hold = _objectSpread({}, hold);
            action.releaseManual.forEach(function (k) {
              delete hold[k];
            });
          }
          // A transition that rewrites SpO2 sets a new baseline, so any apnoea deficit is spent.
          var resetDeficit = Array.isArray(action.releaseManual) && action.releaseManual.indexOf('spO2') !== -1;
          return _objectSpread(_objectSpread({}, state), {}, {
            baseVitals: base,
            vitals: composeVitals(base, cs ? cs.activeDrugs : [], t, inArrest),
            manualHold: hold,
            hypoxiaDeficit: resetDeficit ? 0 : state.hypoxiaDeficit
          });
        }
      case 'MANUAL_VITAL_UPDATE':
        {
          // Boundary guard: a NaN here propagates into the Firebase payload, which RTDB rejects,
          // and the rejected diff is then retried forever — freezing the student monitor.
          var _action$payload = action.payload,
            key = _action$payload.key,
            value = _action$payload.value;
          if (!isVitalValueSafe(key, value)) return state;
          // A manual pupil write is normalised at the boundary, so nothing downstream ever
          // sees a raw '' / NaN / '4' ambiguity.
          if (isCategoricalVital(key)) {
            var pv = normalisePupils(value);
            var pbase = _objectSpread(_objectSpread({}, state.baseVitals), {}, _defineProperty({}, key, pv));
            return _objectSpread(_objectSpread({}, state), {}, {
              baseVitals: pbase,
              vitals: _objectSpread(_objectSpread({}, state.vitals), {}, _defineProperty({}, key, pv)),
              prevVitals: _objectSpread({}, state.vitals),
              manualHold: _objectSpread(_objectSpread({}, state.manualHold || {}), {}, _defineProperty({}, key, true))
            });
          }
          var _t = cs ? cs.time : 0;
          // Everything already given stops acting on this obs (muteDrugsFor; the core reducer
          // stores the same change), so the typed number is the number shown, and stays.
          var drugs = muteDrugsFor(cs ? cs.activeDrugs : [], key);
          var _inArrest = cs ? PULSELESS_RHYTHMS.indexOf(cs.rhythm) !== -1 : false;
          // The facilitator types the number they want to SEE. Store it in base space by
          // removing whatever the drugs are currently contributing, so the displayed value is
          // exactly what was asked for and any later wear-off still unwinds correctly.
          var baseValue = value;
          if (typeof value === 'number') {
            var offs = drugOffsets(drugs, _t);
            var ceils = drugCeilings(drugs, _t);
            var off = _inArrest && ARREST_SUPPRESSED.indexOf(key) !== -1 ? 0 : offs[key] || 0;
            baseValue = clampVital(key, baseForDisplayed(key, value, off, ceils[key]));
          }
          var _base = _objectSpread(_objectSpread({}, state.baseVitals), {}, _defineProperty({}, key, baseValue));
          // A typed value wins over a running trend (Better, Worse, a drug's stabilising trend):
          // the trend stops steering this obs, and stops altogether if nothing else is left.
          var trends = state.trends;
          if (trends && trends.active && trends.targets && Object.prototype.hasOwnProperty.call(trends.targets, key)) {
            var targets = _objectSpread({}, trends.targets);
            delete targets[key];
            var startVitals = _objectSpread({}, trends.startVitals || {});
            delete startVitals[key];
            var keyed = trends.durations ? {
              durations: dropKey(trends.durations, key),
              elapsedBy: dropKey(trends.elapsedBy, key)
            } : {};
            trends = Object.keys(targets).length ? _objectSpread(_objectSpread({}, trends), {}, {
              targets: targets,
              startVitals: startVitals
            }, keyed) : _objectSpread(_objectSpread({}, trends), {}, {
              active: false,
              targets: {},
              startVitals: {}
            }, trends.durations ? {
              durations: {},
              elapsedBy: {}
            } : {});
          }
          // Record that the facilitator typed this one. See `manualHold`.
          // A typed SpO2 is the new baseline: any earlier apnoea deficit no longer applies.
          return _objectSpread(_objectSpread({}, state), {}, {
            baseVitals: _base,
            vitals: composeVitals(_base, drugs, _t, _inArrest),
            prevVitals: _objectSpread({}, state.vitals),
            manualHold: _objectSpread(_objectSpread({}, state.manualHold || {}), {}, _defineProperty({}, key, true)),
            trends: trends,
            hypoxiaDeficit: key === 'spO2' ? 0 : state.hypoxiaDeficit
          });
        }
      case 'START_TREND':
        {
          var safeTargets = {};
          var t0 = cs ? cs.time : 0;
          var _offs = drugOffsets(cs ? cs.activeDrugs : [], t0);
          var _ceils = drugCeilings(cs ? cs.activeDrugs : [], t0);
          Object.keys(action.payload.targets || {}).forEach(function (k) {
            if (!isVitalValueSafe(k, action.payload.targets[k])) return;
            var raw = action.payload.targets[k];
            // Targets are given in DISPLAYED space ("take the BP to 90"); convert to base space
            // by removing the drug contribution present at the moment the trend starts, so the
            // trend and the envelope add up to the number the facilitator asked for.
            safeTargets[k] = typeof raw === 'number' && _offs[k] ? clampVital(k, baseForDisplayed(k, raw, _offs[k], _ceils[k])) : raw;
          });
          if (Object.keys(safeTargets).length === 0) return state;
          // Each obs keeps its OWN time period (Jake: "if I change multiple obs over different time
          // periods they all change over the appropriate time"). A new change no longer replaces the
          // ramps already running: those carry on with their own start, target, length and progress,
          // and only an obs named again starts afresh from where it is now.
          return _objectSpread(_objectSpread({}, state), {}, {
            trends: mergeTrend(state.trends, safeTargets, state.baseVitals, action.payload.duration)
          });
        }
      case 'STOP_TREND':
        return _objectSpread(_objectSpread({}, state), {}, {
          trends: _objectSpread(_objectSpread({}, state.trends), {}, {
            active: false,
            elapsed: 0
          })
        });
      // The facilitator hands typed vitals back to the ventilator ("Release to ventilator").
      case 'RELEASE_MANUAL_HOLD':
        {
          var keys = Array.isArray(action.payload) ? action.payload : [];
          if (!keys.length) return state;
          var _hold = _objectSpread({}, state.manualHold || {});
          keys.forEach(function (k) {
            delete _hold[k];
          });
          return _objectSpread(_objectSpread({}, state), {}, {
            manualHold: _hold
          });
        }
      // The ventilator's second while the session clock is stopped (before START, or paused):
      // breathing for the patient is not a property of scenario time.
      case 'TICK_VENT':
        {
          var _base2 = _objectSpread({}, state.baseVitals);
          var _t2 = cs ? cs.time : 0;
          var vt = ventTick(state, cs, _base2, _t2);
          if (!vt.changed) return state;
          var _inArrest2 = cs ? RG.inArrest(cs.rhythm || 'Sinus Rhythm') : false;
          return _objectSpread(_objectSpread({}, state), {}, {
            baseVitals: _base2,
            vitals: composeVitals(_base2, cs ? cs.activeDrugs || [] : [], _t2, _inArrest2),
            ventPhys: vt.ventPhys,
            hypoxiaTimer: vt.driving ? 0 : state.hypoxiaTimer
          });
        }
      case 'TRIGGER_IMPROVE':
      case 'TRIGGER_DETERIORATE':
        {
          // Trend Better / Worse steers the obs it names over its own 30 s; any other obs already
          // changing over its own period carries on. Targets are displayed-space numbers ("SpO2
          // to 99"), converted to base space exactly as START_TREND does, so a drug's offset is
          // not added on top of the number the facilitator saw.
          var _t3 = action.payload.trends || {};
          var _t4 = cs ? cs.time : 0;
          var _offs2 = drugOffsets(cs ? cs.activeDrugs : [], _t4);
          var _ceils2 = drugCeilings(cs ? cs.activeDrugs : [], _t4);
          var _targets = {};
          Object.keys(_t3.targets || {}).forEach(function (k) {
            var raw = _t3.targets[k];
            _targets[k] = typeof raw === 'number' && _offs2[k] ? clampVital(k, baseForDisplayed(k, raw, _offs2[k], _ceils2[k])) : raw;
          });
          return _objectSpread(_objectSpread({}, state), {}, {
            trends: mergeTrend(state.trends, _targets, _t3.startVitals || state.baseVitals, _t3.duration)
          });
        }
      // ======================= WAVE 6 / QUICK SIM RAMPS ==========================================
      // A ramp ("take the HR to 130 over 120 s") is the facilitator's own instruction and must
      // progress as soon as it is given. Before Wave 6 the ONLY thing that advanced a trend was
      // TICK_TIME, and the 1 Hz interval that dispatches it is gated on isRunning — so a ramp
      // started before START silently did nothing. Quick Sim skips the briefing screen and
      // therefore never calls engine.start(), which is why the bug showed up there first: in
      // Quick Sim the controller normally sits at 00:00 for the whole teaching session.
      //
      // TICK_TRENDS advances ONLY the trend layer. It does not touch the session clock, the
      // drug pk clock, autonomous deterioration, the airway model, the hypoxia timer or the
      // debrief history — all of those are properties of elapsed scenario time and must stay
      // gated on the clock. The precedence order is unchanged: this is step 2 running on its
      // own, with the drug envelope still applied last by composeVitals().
      case 'TICK_TRENDS':
        {
          if (!state.trends || !state.trends.active) return state;
          var _base3 = _objectSpread({}, state.baseVitals);
          var newTrends = _objectSpread({}, state.trends);
          var step = advanceTrendsOneSecond(_base3, newTrends);
          if (!step.ran) return state;
          var _t5 = cs ? cs.time : 0;
          var _inArrest3 = cs ? RG.inArrest(cs.rhythm || 'Sinus Rhythm') : false;
          var composed = composeVitals(_base3, cs ? cs.activeDrugs || [] : [], _t5, _inArrest3);
          return _objectSpread(_objectSpread({}, state), {}, {
            baseVitals: _base3,
            vitals: composed,
            prevVitals: state.prevVitals,
            trends: newTrends
          });
        }
      case 'TICK_TIME':
        {
          // ===== THE COMPOSITION PIPELINE (precedence order documented at the top of this file).
          // Everything from here to step 5 operates on `base` (unrounded underlying physiology).
          // The drug envelope is added at the very end and is never written into `base`.
          var _base4 = _objectSpread({}, state.baseVitals);
          var vitalsChanged = false;
          var _newTrends = _objectSpread({}, state.trends);
          var currentHypoxiaTimer = state.hypoxiaTimer;
          var hypoxiaDeficit = Math.max(0, Number(state.hypoxiaDeficit) || 0);
          var isRunning = cs ? cs.isRunning : false;
          var activeInt = cs ? cs.activeInterventions : new Set();
          var icp = cs ? cs.icp : 10;
          var scen = cs ? cs.scenario : null;
          var rhythm = cs ? cs.rhythm : 'Sinus Rhythm';
          var cprActive = cs ? cs.cprInProgress : false;
          var _inArrest4 = RG.inArrest(rhythm); // Registry, not a seventh private list
          var isBagging = isVentilated(activeInt);
          var time0 = cs ? cs.time : 0;
          // coreReducer increments `time` in the same dispatch, so the authoritative clock for
          // this tick is time0 + 1. Every pk/deterioration calculation uses tNow.
          var tNow = time0 + 1;
          var activeDrugs = cs ? cs.activeDrugs || [] : [];
          // A ventilating transport ventilator breathes for the patient: the hypoxia model below stands down.
          var ventDriver = VE && cs ? VE.driverFor(cs) : null;

          // ----- STEP 2: TRENDS. A trend interpolates the BASE from a base-space snapshot
          // towards base-space targets. Because it no longer touches the displayed vitals, the
          // Wave 1 defect where a trend erased a drug effect within one second is structurally
          // impossible: the drug lives in a separate additive layer.
          // The interpolation itself now lives in advanceTrendsOneSecond() so the
          // clock-independent trend tick (TICK_TRENDS) runs the IDENTICAL maths — a ramp must
          // behave the same whether or not the session clock is running.
          var trendStep = advanceTrendsOneSecond(_base4, _newTrends);
          var trendOwned = trendStep.owned;
          if (trendStep.ran) vitalsChanged = true;

          // ----- STEP 3: AUTONOMOUS DETERIORATION (Group C).
          // Gated on deteriorationMode === 'auto'. Integrating into `base` is what guarantees C3:
          // switching modes only starts/stops the integration, so there is no discontinuity in
          // either direction — the current obs ARE the baseline.
          var detMode = cs ? cs.deteriorationMode || 'manual' : 'manual';
          var det = scen && scen.deterioration ? scen.deterioration : null;
          var detType = det ? normaliseDeteriorationType(det.type) : null;
          var detRate = det ? Number(det.rate) : 0;
          // A RATE-DRIVEN vital (active warming/cooling, fixed-rate insulin)
          // is owned by its drive for exactly as long as the drive runs, in the same way a
          // running trend owns its targets. Without this, autonomous deterioration and the drive
          // both integrate into the same base value in the same tick and the net movement no
          // longer matches either declared rate. No current deterioration type touches `temp`,
          // so this is defensive today and correct by construction tomorrow.
          var driveOwned = drivenVitals(activeDrugs, tNow);
          var ownedBySomething = _objectSpread(_objectSpread({}, trendOwned), driveOwned);
          if (isRunning && detMode === 'auto' && det && det.active !== false && detType && Number.isFinite(detRate) && detRate > 0 && !_inArrest4) {
            var factor = deteriorationTreatmentFactor(detType, cs);
            if (factor !== 0 && applyDeteriorationTick(_base4, detType, detRate, factor, ownedBySomething)) vitalsChanged = true;
          }

          // ----- STEP 3b: RATE-DRIVEN VITALS (Wave 4a, PART 2D).
          // Active warming/cooling and a fixed-rate insulin infusion move a vital at a RATE
          // towards a TARGET. They integrate into the BASE (like deterioration) rather than
          // sitting in the additive envelope, which is what lets a 30.0 degC patient actually
          // reach 36.8 and a pyrexial one actually come down. drugOffsets() excludes these
          // vitals from the envelope for exactly as long as the drive is running, so no
          // effect is ever applied twice.
          if (isRunning && applyDriveTick(_base4, activeDrugs, tNow)) vitalsChanged = true;

          // ----- STEP 4: AIRWAY / PARALYSIS / HYPOXIA / ETCO2.
          // PARALYSIS is now derived from the SAME activeDrugs entry as the drug's numeric
          // envelope (Wave 1 left a bespoke parallel timer with a note asking for this). Once the
          // blocker's onset has passed, respiration is the ventilator rate if the patient is
          // being ventilated and ZERO if not, which feeds the hypoxia model below.
          var paraFromDrugs = paralysisFromDrugs(activeDrugs, tNow);
          var paraPhase = paraFromDrugs ? 'active' : paralysisPhase(cs ? cs.paralysis : null, tNow);
          if (!_inArrest4 && paraPhase === 'active') {
            // Ventilated: the DISPLAYED rate is the ventilation rate, so the drug envelope's RR
            // offset (opioids, sedatives) is taken off the base, as ventTick does; otherwise
            // a ventilated, paralysed patient showed fewer breaths than were being given.
            var targetRr = isBagging ? clampVital('rr', VENTILATOR_RATE - (drugOffsets(activeDrugs, tNow).rr || 0)) : 0;
            if (_base4.rr !== targetRr) {
              _base4.rr = targetRr;
              vitalsChanged = true;
            }
          }

          // Hypoxia: SpO2 falls if hypoventilating or apnoeic without ventilatory support.
          // NOTE this reads the DISPLAYED spO2/rr of the previous tick (state.vitals), because a
          // drug that is currently supporting respiration or oxygenation genuinely should stop
          // the patient desaturating — the model must see what the monitor sees.
          var seenSpO2 = Number.isFinite(state.vitals.spO2) ? state.vitals.spO2 : _base4.spO2;
          var seenRr = !_inArrest4 && paraPhase === 'active' ? _base4.rr : Number.isFinite(state.vitals.rr) ? state.vitals.rr : _base4.rr;
          if (!_inArrest4 && seenSpO2 > 0 && (seenRr < 8 || seenRr <= 0) && !isBagging && !ventDriver) {
            currentHypoxiaTimer++;
            // E4 / WAVE 4a: SAFE APNOEA TIME, age- and physiology-appropriate.
            // Was: 40 s with pre-oxygenation, 10 s without, for every patient of every age.
            // Three minutes of good pre-oxygenation buys a healthy adult 6-10 minutes; an
            // infant gets 90-120 s; a septic/pregnant/obese patient far less. Teaching that
            // pre-oxygenation buys 30 extra seconds is dangerous in RSI and in paediatrics.
            var preoxygenated = activeInt.has('Preoxygenation') || activeInt.has('Bagging') || activeInt.has('NIV') || activeInt.has('CPAP');
            var apnoeicO2 = activeInt.has('ApnoeicOxygenation');
            var preoxDur = cs && cs.activeDurations && cs.activeDurations['Preoxygenation'] ? Math.max(0, tNow - cs.activeDurations['Preoxygenation'].startTime) : preoxygenated ? 180 : 0;
            var graceSeconds = safeApnoeaSeconds(scen, {
              preoxygenated: preoxygenated,
              apnoeicO2: apnoeicO2,
              preoxSeconds: preoxDur,
              startingSpO2: seenSpO2,
              highConsumption: hasHighO2Consumption(scen)
            });
            if (currentHypoxiaTimer > graceSeconds) {
              // Steeper drop below 88 (Severinghaus curve)
              var dropRate = seenSpO2 < 88 ? 1.5 : 0.5;
              if (apnoeicO2) dropRate = dropRate / 2;
              var before = _base4.spO2;
              _base4.spO2 = Math.max(20, _base4.spO2 - dropRate);
              hypoxiaDeficit += Math.max(0, before - _base4.spO2);
              vitalsChanged = true;
            }
          } else {
            currentHypoxiaTimer = 0;
            // Recovery. Wave 1 had to step a whole point every 3 s because SpO2 was stored as
            // an integer and +0.2/s rounded straight back. `base` is now unrounded, so a smooth
            // +0.35/s is both correct and visible. Count any positive-pressure or high-flow
            // source, not just the 'Oxygen' key.
            //
            // Only the DEFICIT the apnoea model above created is recovered here. The oxygen
            // sources' own pk envelopes already add their SpO2 benefit, so recovering the
            // underlying disease towards 98 as well counted oxygen twice and took every
            // hypoxic patient (pneumonia, PJP, AUTO deterioration running) to 100% within a
            // minute. No recovery at all in a pulseless rhythm: there is no circulation.
            var oxygenSource = activeInt.has('Oxygen') || activeInt.has('Preoxygenation') || activeInt.has('ApnoeicOxygenation') || isBagging;
            if (!_inArrest4 && oxygenSource && hypoxiaDeficit > 0 && _base4.spO2 < 98) {
              var _step = Math.min(0.35, hypoxiaDeficit, 98 - _base4.spO2);
              _base4.spO2 += _step;
              hypoxiaDeficit -= _step;
              vitalsChanged = true;
            }
          }

          // The Cushing response and the ETCO2 drift below are autonomous physiology, so they
          // belong to AUTO mode only (README: in MANUAL nothing changes unless the facilitator
          // changes it), and never move an obs the facilitator has typed or a trend/drive owns.
          var hold0 = cs && cs.manualHold || {};
          var autoMay = function autoMay(k) {
            return detMode === 'auto' && !hold0[k] && !ownedBySomething[k];
          };
          if (scen && scen.deterioration && detType === 'neuro' && isRunning && !_inArrest4 && detMode === 'auto') {
            if (icp > 25) {
              if (autoMay('bpSys')) _base4.bpSys = Math.min(220, _base4.bpSys + 0.2);
              if (autoMay('bpDia')) _base4.bpDia = Math.min(180, _base4.bpDia + 0.12);
              if (autoMay('hr')) _base4.hr = Math.max(30, _base4.hr - 0.1);
              vitalsChanged = true;
            } else if (icpTherapy(cs, tNow).treated && scen.vitals) {
              // The ICP has been brought down by treatment: the Cushing response eases back
              // towards the scenario's own starting obs, at the rate it came on.
              var _sv = scen.vitals;
              var toward = function toward(k, step) {
                var target = Number(_sv[k]);
                if (!Number.isFinite(target) || !autoMay(k) || !Number.isFinite(_base4[k])) return;
                if (_base4[k] > target + 0.01) {
                  _base4[k] = Math.max(target, _base4[k] - step);
                  vitalsChanged = true;
                } else if (_base4[k] < target - 0.01) {
                  _base4[k] = Math.min(target, _base4[k] + step);
                  vitalsChanged = true;
                }
              };
              toward('bpSys', 0.2);
              toward('bpDia', 0.12);
              toward('hr', 0.1);
            }
          }

          // ETCO2 dynamics — non-arrest hyperventilation/hypoventilation
          if (!_inArrest4) {
            if (autoMay('etco2') && _base4.rr > 30) {
              _base4.etco2 = Math.max(2.5, _base4.etco2 - 0.01);
              vitalsChanged = true;
            }
            if (autoMay('etco2') && _base4.rr < 10 && _base4.rr > 0) {
              _base4.etco2 = Math.min(8.0, _base4.etco2 + 0.01);
              vitalsChanged = true;
            }
          } else {
            // Arrest ETCO2 — responds to CPR quality and bagging (key clinical marker)
            var targetEtco2 = 0.8; // poor/no perfusion baseline
            if (cprActive) targetEtco2 += 1.2;
            if (isBagging) targetEtco2 += 1.0;
            if (cprActive && isBagging) targetEtco2 += 0.5; // synergy
            var delta = targetEtco2 - _base4.etco2;
            if (Math.abs(delta) > 0.02) {
              _base4.etco2 = _base4.etco2 + delta * 0.15;
              vitalsChanged = true;
            }
          }

          // ----- STEP 4b: THE VENTILATOR (data/engine-vent.js), after everything above, so
          // what it produces is what the monitor shows (manual holds aside).
          var _vt = ventTick(state, cs, _base4, tNow);
          if (_vt.changed) vitalsChanged = true;
          if (_vt.driving) {
            currentHypoxiaTimer = 0;
            hypoxiaDeficit = 0;
          }

          // ----- STEPS 5 + 6: add the drug envelope, clamp, round. Recomposed EVERY tick from
          // `base` so offsets can never accumulate rounding error, and so a drug wearing off
          // unwinds exactly back onto the underlying trajectory.
          Object.keys(_base4).forEach(function (k) {
            if (typeof _base4[k] === 'number') {
              if (!Number.isFinite(_base4[k])) _base4[k] = state.baseVitals[k];else _base4[k] = clampVital(k, _base4[k]);
            }
          });
          var _composed = composeVitals(_base4, activeDrugs, tNow, _inArrest4);
          // A live drug envelope changes the numbers even on a tick where nothing else moved.
          if (!vitalsChanged) {
            for (var k in _composed) {
              if (_composed[k] !== state.vitals[k]) {
                vitalsChanged = true;
                break;
              }
            }
          }

          // Snapshot prevVitals every 15 seconds so trend arrows reflect recent direction.
          var time = cs ? cs.time : 0;
          var nextPrev = state.prevVitals;
          if (time > 0 && time % 15 === 0) {
            nextPrev = _objectSpread({}, state.vitals);
          }
          return _objectSpread(_objectSpread({}, state), {}, {
            baseVitals: _base4,
            vitals: vitalsChanged ? _composed : state.vitals,
            prevVitals: nextPrev,
            trends: _newTrends,
            hypoxiaTimer: currentHypoxiaTimer,
            hypoxiaDeficit: hypoxiaDeficit,
            ventPhys: _vt.ventPhys
          });
        }
      default:
        return state;
    }
  };

  // The debrief timeline (see sessionTime in engine-model.js). Older states carry only `time`.
  var sessionSeconds = function sessionSeconds(cs) {
    return cs ? Number.isFinite(cs.sessionTime) ? cs.sessionTime : Number(cs.time) || 0 : 0;
  };
  var clockText = function clockText(t) {
    return "".concat(Math.floor(t / 60).toString().padStart(2, '0'), ":").concat((t % 60).toString().padStart(2, '0'));
  };
  var logReducer = function logReducer(state, action) {
    var cs = action.currentState;
    switch (action.type) {
      case 'CLEAR_SESSION':
        return _objectSpread({}, initialLogState);
      case 'LOAD_SCENARIO':
        return _objectSpread({}, initialLogState);
      case 'RESTORE_SESSION':
        return {
          log: action.payload.log || [],
          history: action.payload.history || []
        };
      case 'START_SIM':
        return _objectSpread(_objectSpread({}, state), {}, {
          log: [].concat(_toConsumableArray(state.log), [{
            time: new Date().toLocaleTimeString('en-GB'),
            simTime: clockText(sessionSeconds(cs)),
            msg: "Simulation Started",
            type: 'system',
            timeSeconds: sessionSeconds(cs)
          }])
        });
      case 'PAUSE_SIM':
        return _objectSpread(_objectSpread({}, state), {}, {
          log: [].concat(_toConsumableArray(state.log), [{
            time: new Date().toLocaleTimeString('en-GB'),
            simTime: clockText(sessionSeconds(cs)),
            msg: "Simulation Paused",
            type: 'system',
            timeSeconds: sessionSeconds(cs)
          }])
        });
      case 'ADD_LOG':
        var timestamp = new Date().toLocaleTimeString('en-GB');
        var tLog = sessionSeconds(cs);
        // `deviation` carries the structured "performed WITHOUT" record so the debrief can
        // render a Sequence deviations card rather than re-parsing log text.
        return _objectSpread(_objectSpread({}, state), {}, {
          log: [].concat(_toConsumableArray(state.log), [{
            time: timestamp,
            simTime: clockText(tLog),
            msg: action.payload.msg,
            type: action.payload.type,
            flagged: action.payload.flagged || false,
            deviation: action.payload.deviation || null,
            timeSeconds: tLog
          }])
        });
      case 'TOGGLE_FLAG':
        var newLog = _toConsumableArray(state.log);
        if (newLog[action.payload]) {
          newLog[action.payload] = _objectSpread(_objectSpread({}, newLog[action.payload]), {}, {
            flagged: !newLog[action.payload].flagged
          });
        }
        return _objectSpread(_objectSpread({}, state), {}, {
          log: newLog
        });
      // The debrief's obs record: one sample every 5 s of session time, whichever clock is
      // running it (TICK_TIME, or Quick Sim's record-only TICK_RECORD).
      // Finish, and every rhythm change, add a sample at that second too, so the graph's last
      // point and its rhythm bar show what the patient was actually in (a ROSC seconds before
      // Finish used to be missing from the graph entirely).
      case 'STOP_SIM':
      case 'UPDATE_RHYTHM':
      case 'TICK_TIME':
      case 'TICK_RECORD':
        {
          var t = sessionSeconds(cs);
          if (!cs) return state;
          // A rhythm change is sampled under the NEW rhythm (the vitals follow a tick later).
          var rhythm = action.type === 'UPDATE_RHYTHM' ? RG.canonical(action.payload) : cs.rhythm;
          var last = state.history.length ? state.history[state.history.length - 1] : null;
          if (action.type === 'TICK_TIME' || action.type === 'TICK_RECORD') {
            if (t % 5 !== 0) return state;
          } else if (last && last.time === t && last.rhythm === rhythm) return state;
          var v = cs.vitals || {};
          var sample = {
            time: t,
            hr: v.hr,
            bp: v.bpSys,
            bpDia: v.bpDia,
            spo2: v.spO2,
            rr: v.rr,
            etco2: v.etco2,
            co2: cs.etco2Enabled ? 1 : 0,
            temp: v.temp,
            bm: v.bm,
            ph: v.ph,
            gcs: v.gcs,
            rhythm: rhythm
          };
          return _objectSpread(_objectSpread({}, state), {}, {
            history: [].concat(_toConsumableArray(state.history), [sample])
          });
        }
      default:
        return state;
    }
  };
  var scenarioReducer = function scenarioReducer(state, action) {
    switch (action.type) {
      case 'CLEAR_SESSION':
        return _objectSpread({}, initialScenarioState);
      case 'LOAD_SCENARIO':
        return _objectSpread(_objectSpread({}, initialScenarioState), {}, {
          scenario: action.payload
        });
      case 'RESTORE_SESSION':
        return {
          scenario: window.rehydrateScenario(action.payload.scenario),
          investigationsRevealed: action.payload.investigationsRevealed || {},
          loadingInvestigations: action.payload.loadingInvestigations || {}
        };
      case 'SYNC_FROM_MASTER':
        var syncedScenario = _objectSpread(_objectSpread({}, state.scenario), {}, {
          title: action.payload.scenarioTitle,
          patientName: action.payload.patientName,
          patientAge: action.payload.patientAge,
          sex: action.payload.sex,
          ageRange: action.payload.ageRange,
          wetflag: action.payload.wetflag,
          deterioration: {
            type: action.payload.pathology
          }
        }, action.payload.investigations);
        // A result the controller no longer has (the database drops nulls) must not linger
        // here from an earlier sync: e.g. an X-ray the facilitator chose and then undid.
        if (action.payload.investigations && _typeof(action.payload.investigations) === 'object') {
          ['vbg', 'ecg', 'chestXray', 'urine', 'ct', 'pocus'].forEach(function (k) {
            if (action.payload.investigations[k] === undefined) syncedScenario[k] = null;
          });
        }
        return _objectSpread(_objectSpread({}, state), {}, {
          scenario: syncedScenario
        });
      case 'UPDATE_SCENARIO':
        return _objectSpread(_objectSpread({}, state), {}, {
          scenario: action.payload
        });
      case 'REVEAL_INVESTIGATION':
        return _objectSpread(_objectSpread({}, state), {}, {
          investigationsRevealed: _objectSpread(_objectSpread({}, state.investigationsRevealed), {}, _defineProperty({}, action.payload, true)),
          loadingInvestigations: _objectSpread(_objectSpread({}, state.loadingInvestigations), {}, _defineProperty({}, action.payload, false))
        });
      case 'SET_LOADING_INVESTIGATION':
        return _objectSpread(_objectSpread({}, state), {}, {
          loadingInvestigations: _objectSpread(_objectSpread({}, state.loadingInvestigations), {}, _defineProperty({}, action.payload, true))
        });
      default:
        return state;
    }
  };
  var coreReducer = function coreReducer(state, action) {
    var cs = action.currentState;
    switch (action.type) {
      // A typed obs: the drugs already given stop acting on it (see the vitals reducer).
      case 'MANUAL_VITAL_UPDATE':
        {
          var key = action.payload && action.payload.key;
          if (!key || isCategoricalVital(key) || !isVitalValueSafe(key, action.payload.value) || !(state.activeDrugs || []).length) return state;
          return _objectSpread(_objectSpread({}, state), {}, {
            activeDrugs: muteDrugsFor(state.activeDrugs, key)
          });
        }
      case 'CLEAR_SESSION':
        return _objectSpread(_objectSpread({}, initialCoreState), {}, {
          runId: null,
          activeInterventions: new Set(),
          interventionCounts: {},
          isOffline: state.isOffline,
          syncStatus: state.syncStatus,
          remotePresence: state.remotePresence
        });
      case 'LOAD_SCENARIO':
        if (!action.payload) return _objectSpread(_objectSpread({}, initialCoreState), {}, {
          runId: null,
          activeInterventions: new Set(),
          interventionCounts: {},
          isOffline: state.isOffline,
          syncStatus: state.syncStatus,
          remotePresence: state.remotePresence
        });
        var initialRhythm = action.payload.ecg && action.payload.ecg.type ? action.payload.ecg.type : "Sinus Rhythm";
        var startICP = 10;
        if (action.payload.category === 'Trauma' && (action.payload.title || '').includes('Head')) startICP = 25;
        // Default to AUTO for any scenario that declares deterioration, MANUAL otherwise.
        // The mode is logged at scenario start and on every change so a facilitator who never
        // touches the toggle is never surprised by moving numbers.
        var det0 = action.payload.deterioration || null;
        var detMode0 = det0 && det0.active && normaliseDeteriorationType(det0.type) && Number(det0.rate) > 0 ? 'auto' : 'manual';
        // WAVE 4b / A2 + A6: QUICK SIM. The synthetic blank patient carries no `deterioration`
        // block, so detMode0 resolves to 'manual' with no special case — requirement A6 — while
        // the AUTO/MANUAL toggle stays available because it is state-driven, not scenario-driven.
        //
        // Monitoring is NOT seeded, in Quick Sim or anywhere else: every launch mode starts
        // with nothing attached ("NO SENSOR DETECTED"), and the facilitator attaches the
        // standard set or individual sensors from the controller's Monitoring & access panel.
        // (Quick Sim used to seed 'Obs' here; it no longer does, by request.)
        return _objectSpread(_objectSpread(_objectSpread({}, initialCoreState), {}, {
          runId: action.runId || newRunId(),
          rhythm: initialRhythm,
          icp: startICP,
          isOffline: state.isOffline,
          syncStatus: state.syncStatus,
          // The joined screens are still joined: keep them, or the badge says "no screens linked" until the next heartbeat.
          remotePresence: state.remotePresence,
          showWetflag: action.payload.showWetflag === true,
          deteriorationMode: detMode0,
          defibSettings: cleanDefibSettings(initialCoreState.defibSettings, action.payload.defibSettings),
          pacingThreshold: Number(action.payload.pacingThreshold) > 0 ? Number(action.payload.pacingThreshold) : initialCoreState.pacingThreshold,
          arrest: {
            since: RG.isPulseless(initialRhythm) ? 0 : null,
            shocks: 0,
            adrenaline: [],
            amiodarone: []
          },
          defibStep: action.payload.defibSim && Array.isArray(action.payload.defibSim.steps) && action.payload.defibSim.steps.length ? {
            index: 0,
            since: 0,
            done: false
          } : null
        }, action.payload.ventSim && window.VENT_PROFILES ? {
          vent: {
            profile: window.VENT_PROFILES.profiles[action.payload.ventSim.profile] ? action.payload.ventSim.profile : 'normal',
            breathing: action.payload.ventSim.breathing === true || action.payload.ventSim.breathing === false ? action.payload.ventSim.breathing : null,
            lung: ventSimLung(action.payload.ventSim.lung),
            probs: window.VENT_PROFILES.probList(action.payload.ventSim.startProblems || []),
            assess: action.payload.ventSim.mode === 'assessment',
            model: window.VENT_PROFILES.modelOf(action.payload.ventSim.device)
          },
          ventPanelOpen: true
        } : {}), {}, {
          // Always a FRESH Set: initialCoreState holds one shared instance, so spreading it
          // would hand every session the same object. It starts with the kit the scenario says
          // is already on from the scene (scenario.setupKit, data/prehospital.js): on the picture
          // and removable, but with no effect on the obs and not the team's.
          activeInterventions: new Set(window.cleanSetupKit ? window.cleanSetupKit(action.payload.setupKit) : []),
          interventionCounts: {}
        });
      case 'RESTORE_SESSION':
        {
          // Whitelist, never spread. coreState is merged LAST in useSimulation, so any `vitals`,
          // `log` or `scenario` key carried in from the snapshot would shadow the live values
          // owned by the other three reducers for the rest of the session.
          var p = action.payload || {};
          return _objectSpread(_objectSpread({}, state), {}, {
            // Resuming reopens the SAME run, and therefore the same instructor notes.
            // Pre-Wave-4b snapshots carry no runId, so mint one rather than leaving it null.
            runId: p.runId || state.runId || action.runId || newRunId(),
            time: p.time || 0,
            sessionTime: Number.isFinite(p.sessionTime) ? p.sessionTime : p.time || 0,
            cycleTimer: p.cycleTimer || 0,
            rhythm: p.rhythm || state.rhythm,
            interventionCounts: p.interventionCounts || {},
            activeDurations: p.activeDurations || {},
            nibp: p.nibp || state.nibp,
            etco2Enabled: !!p.etco2Enabled,
            isParalysed: !!p.isParalysed,
            paralysis: p.paralysis || {
              active: !!p.isParalysed,
              agent: null,
              startTime: 0,
              onset: 0,
              duration: 0
            },
            showWetflag: p.showWetflag === true,
            icp: p.icp === undefined || p.icp === null ? 10 : p.icp,
            activeDrugs: Array.isArray(p.activeDrugs) ? p.activeDrugs : [],
            deteriorationMode: p.deteriorationMode === 'auto' ? 'auto' : 'manual',
            // Shock count / cumulative energy survive a resume now that they live in
            // state rather than in a useRef that reset to zero.
            defib: _objectSpread(_objectSpread({}, initialCoreState.defib), p.defib || {}),
            defibSettings: cleanDefibSettings(initialCoreState.defibSettings, p.defibSettings),
            arrest: p.arrest && _typeof(p.arrest) === 'object' ? {
              since: Number.isFinite(p.arrest.since) ? p.arrest.since : null,
              shocks: Number(p.arrest.shocks) || 0,
              adrenaline: Array.isArray(p.arrest.adrenaline) ? p.arrest.adrenaline : [],
              amiodarone: Array.isArray(p.arrest.amiodarone) ? p.arrest.amiodarone : []
            } : initialCoreState.arrest,
            defibStep: p.defibStep && Number.isFinite(p.defibStep.index) ? {
              index: p.defibStep.index,
              since: Number(p.defibStep.since) || 0,
              done: !!p.defibStep.done
            } : null,
            lastConversion: p.lastConversion || null,
            vent: p.vent && _typeof(p.vent) === 'object' && window.VENT_PROFILES && window.VENT_PROFILES.profiles[p.vent.profile] ? {
              profile: p.vent.profile,
              breathing: p.vent.breathing === true || p.vent.breathing === false ? p.vent.breathing : null,
              lung: p.vent.lung && _typeof(p.vent.lung) === 'object' ? _objectSpread({}, p.vent.lung) : {},
              probs: window.VENT_PROFILES.probList(p.vent.probs),
              assess: p.vent.assess === true,
              model: window.VENT_PROFILES.modelOf(p.vent.model)
            } : null,
            activeInterventions: new Set(p.activeInterventions || []),
            completedObjectives: new Set(p.completedObjectives || []),
            // Point-of-care results and compressions in progress, when the snapshot carries them.
            pocReadings: p.pocReadings && _typeof(p.pocReadings) === 'object' ? _objectSpread({}, p.pocReadings) : {},
            ventSamples: Array.isArray(p.ventSamples) ? p.ventSamples.slice(-480) : [],
            cprInProgress: p.cprInProgress === undefined ? state.cprInProgress : !!p.cprInProgress,
            // The room monitor's devices, capnography shape and sound (older snapshots lack them).
            ventPanelOpen: p.ventPanelOpen === undefined ? state.ventPanelOpen : !!p.ventPanelOpen,
            defibPanelOpen: p.defibPanelOpen === undefined ? state.defibPanelOpen : !!p.defibPanelOpen,
            etco2Pathology: typeof p.etco2Pathology === 'string' ? p.etco2Pathology : state.etco2Pathology,
            audioOutput: typeof p.audioOutput === 'string' ? p.audioOutput : state.audioOutput,
            isMuted: p.isMuted === undefined ? state.isMuted : !!p.isMuted,
            waveformGain: Number.isFinite(p.waveformGain) && p.waveformGain > 0 ? p.waveformGain : state.waveformGain,
            noise: p.noise && _typeof(p.noise) === 'object' ? _objectSpread(_objectSpread({}, state.noise), p.noise) : state.noise,
            metronomeOn: p.metronomeOn === undefined ? state.metronomeOn : !!p.metronomeOn,
            pacing: p.pacing && _typeof(p.pacing) === 'object' ? _objectSpread(_objectSpread({}, state.pacing), p.pacing) : state.pacing,
            remotePacerState: p.remotePacerState && _typeof(p.remotePacerState) === 'object' ? {
              rate: Number(p.remotePacerState.rate) || 0,
              output: Number(p.remotePacerState.output) || 0
            } : state.remotePacerState,
            pacingThreshold: Number(p.pacingThreshold) > 0 ? Number(p.pacingThreshold) : p.scenario && Number(p.scenario.pacingThreshold) > 0 ? Number(p.scenario.pacingThreshold) : state.pacingThreshold,
            ventLink: p.ventLink !== false,
            assessments: p.assessments && _typeof(p.assessments) === 'object' ? _objectSpread({}, p.assessments) : {},
            // A resumed session is NOT a paused session. Its clock is
            // non-zero and it is not running, which Wave 6 read as "deliberately paused" and
            // therefore froze the controller's waveform strip until START was pressed. The
            // pause marker is deliberately NOT restored from the snapshot: a page reload can
            // only ever produce "restored, not yet started".
            pausedAt: null,
            isRunning: false
          });
        }
      case 'START_SIM':
        return _objectSpread(_objectSpread({}, state), {}, {
          isRunning: true,
          isFinished: false,
          pausedAt: null
        });
      // A deliberate facilitator pause — and the ONLY thing that sets the pause marker. The
      // marker is the sim-clock second it happened at, so it is a primitive and survives sync.
      case 'PAUSE_SIM':
        return _objectSpread(_objectSpread({}, state), {}, {
          isRunning: false,
          pausedAt: Number.isFinite(state.time) ? state.time : 0
        });
      case 'STOP_SIM':
        return _objectSpread(_objectSpread({}, state), {}, {
          isRunning: false,
          isFinished: true
        });
      // Finish pressed by mistake: back into the same run, paused, with everything as it was.
      // The run comes back PAUSED (pausedAt set), not "not started": Finish pressed while running
      // left pausedAt null, so the controller showed the set-up banner and the patient screens
      // went blank until START.
      case 'UNDO_FINISH':
        return _objectSpread(_objectSpread({}, state), {}, {
          isRunning: false,
          isFinished: false,
          pausedAt: state.pausedAt !== null && state.pausedAt !== undefined ? state.pausedAt : Number.isFinite(state.time) ? state.time : 0
        });
      case 'SET_OFFLINE':
        return _objectSpread(_objectSpread({}, state), {}, {
          isOffline: action.payload
        });
      case 'SET_SYNC_STATUS':
        {
          var _action$payload2, _action$payload3, _action$payload4, _state$syncStatus;
          var syncStatus = {
            state: ((_action$payload2 = action.payload) === null || _action$payload2 === void 0 ? void 0 : _action$payload2.state) || 'error',
            message: ((_action$payload3 = action.payload) === null || _action$payload3 === void 0 ? void 0 : _action$payload3.message) || null,
            lastWriteAt: ((_action$payload4 = action.payload) === null || _action$payload4 === void 0 ? void 0 : _action$payload4.lastWriteAt) || ((_state$syncStatus = state.syncStatus) === null || _state$syncStatus === void 0 ? void 0 : _state$syncStatus.lastWriteAt) || null
          };
          return _objectSpread(_objectSpread({}, state), {}, {
            syncStatus: syncStatus,
            isOffline: SYNC_OFFLINE_STATES.has(syncStatus.state)
          });
        }
      case 'TICK_TIME':
        var newDurations = _objectSpread({}, state.activeDurations);
        var durChanged = false;
        Object.keys(newDurations).forEach(function (key) {
          var elapsed = state.time + 1 - newDurations[key].startTime;
          if (elapsed >= newDurations[key].duration) {
            delete newDurations[key];
            durChanged = true;
          }
        });
        var newNibp = _objectSpread({}, state.nibp);
        if (newNibp.mode === 'auto') {
          newNibp.timer -= 1;
        }
        var currentICP = state.icp;
        // Raised ICP climbs on its own only in AUTO mode (the Cushing response it drives is
        // AUTO-only too); treatment lowers it in either mode, because treatment is something
        // the team did, not autonomous physiology.
        if (cs && cs.scenario && cs.scenario.deterioration && normaliseDeteriorationType(cs.scenario.deterioration.type) === 'neuro' && state.isRunning && state.time % 10 === 0) {
          var th = icpTherapy(cs, state.time + 1);
          var delta = 0;
          if ((cs.deteriorationMode || 'manual') === 'auto') delta += th.hypercapnic ? 0.2 : th.normocapnic ? 0 : 0.1;
          if (th.osmo > 0) delta -= 0.4 * th.osmo; // osmotherapy at its peak: ~2.4 mmHg/min
          if (th.normocapnic && currentICP > 15) delta -= 0.1; // controlled ventilation, slowly
          currentICP = Math.max(8, Math.min(80, (Number(currentICP) || 10) + delta));
        }
        var newMonitorTimer = _objectSpread({}, state.monitorTimer);
        if (newMonitorTimer.active) {
          newMonitorTimer.time += 1;
        }
        var tNext = state.time + 1;

        // Retire spent drug entries so activeDrugs cannot grow without bound over a long
        // session. A spent entry contributes exactly zero, so pruning is observationally free.
        var nextDrugs = state.activeDrugs || [];
        var kept = nextDrugs.filter(function (d) {
          return !isDrugSpent(d, tNext) && !(d.reversed && pkFactor(d, tNext) <= 0);
        });
        if (kept.length !== nextDrugs.length) nextDrugs = kept;

        // Neuromuscular blockade wears off. Sux (~8 min) and roc (~45 min) therefore diverge,
        // and the patient is no longer permanently paralysed after a single dose. Derived from
        // the activeDrugs entry — ONE timer, per the Wave 1 note.
        var para = paralysisFromDrugs(nextDrugs, tNext);
        var nextParalysis = state.paralysis;
        var nextIsParalysed = state.isParalysed;
        if (para) {
          if (!state.paralysis.active || state.paralysis.agent !== para.agent || state.paralysis.startTime !== para.startTime) {
            nextParalysis = {
              active: true,
              agent: para.agent,
              startTime: para.startTime,
              onset: para.onset,
              duration: para.duration
            };
          }
          nextIsParalysed = true;
        } else if (state.paralysis.active || state.isParalysed) {
          // Either the blockade expired or there never was an activeDrugs entry (legacy
          // restored session). Keep honouring an explicit legacy timer until it expires.
          var legacy = !state.activeDrugs.some(function (d) {
            return d.paralytic;
          }) && paralysisPhase(state.paralysis, tNext) === 'active';
          if (!legacy) {
            nextParalysis = {
              active: false,
              agent: null,
              startTime: 0,
              onset: 0,
              duration: 0
            };
            nextIsParalysed = false;
          }
        }
        return _objectSpread(_objectSpread({}, state), {}, {
          time: tNext,
          sessionTime: (Number(state.sessionTime) || 0) + 1,
          cycleTimer: state.cycleTimer + 1,
          activeDurations: durChanged ? newDurations : state.activeDurations,
          nibp: newNibp,
          icp: currentICP,
          monitorTimer: newMonitorTimer,
          activeDrugs: nextDrugs,
          paralysis: nextParalysis,
          isParalysed: nextIsParalysed
        });
      case 'TOGGLE_MONITOR_TIMER':
        return _objectSpread(_objectSpread({}, state), {}, {
          monitorTimer: _objectSpread(_objectSpread({}, state.monitorTimer), {}, {
            visible: !state.monitorTimer.visible
          })
        });
      case 'START_MONITOR_TIMER':
        return _objectSpread(_objectSpread({}, state), {}, {
          monitorTimer: _objectSpread(_objectSpread({}, state.monitorTimer), {}, {
            active: true
          })
        });
      case 'PAUSE_MONITOR_TIMER':
        return _objectSpread(_objectSpread({}, state), {}, {
          monitorTimer: _objectSpread(_objectSpread({}, state.monitorTimer), {}, {
            active: false
          })
        });
      case 'RESET_MONITOR_TIMER':
        return _objectSpread(_objectSpread({}, state), {}, {
          monitorTimer: _objectSpread(_objectSpread({}, state.monitorTimer), {}, {
            time: 0
          })
        });
      case 'RESET_CYCLE_TIMER':
        return _objectSpread(_objectSpread({}, state), {}, {
          cycleTimer: 0
        });
      case 'UPDATE_RHYTHM':
        {
          // UPDATE_RHYTHM used to log NOTHING; logging was scattered across five
          // call sites with five different formats and three of them logged nothing at all.
          // Every transition now arrives here carrying `cause`/`detail` (see changeRhythm()),
          // and the reducer records the assessor-local announcement state.
          var to = RG.canonical(action.payload);
          var from = state.rhythm;
          var ev = {
            id: action.eventId || Date.now(),
            from: from,
            to: to,
            cause: action.cause || 'unspecified',
            detail: action.detail || null,
            converted: from !== to,
            at: Date.now()
          };
          // A new rhythm starts a new episode for the fixed-count shock and rhythm-check rules.
          var defibAfter = ev.converted ? _objectSpread(_objectSpread({}, state.defib), {}, {
            episodeShocks: 0,
            adrChecks: 0
          }) : state.defib;
          // Arrest bookkeeping: entering a pulseless rhythm from one with a pulse starts a new
          // arrest; leaving it ends the arrest (the record stays for the debrief until the next).
          var arrest0 = state.arrest || initialCoreState.arrest;
          var arrestAfter = arrest0;
          if (RG.isPulseless(to) && arrest0.since === null) arrestAfter = {
            since: Number(state.time) || 0,
            shocks: 0,
            adrenaline: [],
            amiodarone: []
          };else if (!RG.isPulseless(to) && arrest0.since !== null) arrestAfter = _objectSpread(_objectSpread({}, arrest0), {}, {
            since: null
          });
          return _objectSpread(_objectSpread({}, state), {}, {
            rhythm: to,
            rhythmEvent: ev,
            lastConversion: ev.converted ? ev : state.lastConversion,
            defib: defibAfter,
            arrest: arrestAfter
          });
        }
      case 'CLEAR_RHYTHM_EVENT':
        return _objectSpread(_objectSpread({}, state), {}, {
          rhythmEvent: null
        });
      // B5 / A: defibrillator device state + metrics. Merge semantics so a charge does not
      // clobber the running shock tally.
      case 'SET_DEFIB_STATE':
        {
          var nextDefib = _objectSpread(_objectSpread({}, state.defib), action.payload || {});
          var a = state.arrest || initialCoreState.arrest;
          var shocked = (Number(nextDefib.shockCount) || 0) > (Number(state.defib && state.defib.shockCount) || 0);
          return _objectSpread(_objectSpread({}, state), {}, {
            defib: nextDefib,
            arrest: shocked && a.since !== null ? _objectSpread(_objectSpread({}, a), {}, {
              shocks: a.shocks + 1
            }) : a
          });
        }
      case 'SET_DEFIB_STEP':
        return _objectSpread(_objectSpread({}, state), {}, {
          defibStep: action.payload ? _objectSpread(_objectSpread({}, state.defibStep || {}), action.payload) : null
        });
      // Trace artefacts and variations shown on the learner's monitor and defib: only these
      // keys. ECG artefacts are booleans; pleth and art are one of a fixed set of styles;
      // artFlush counts fast-flush tests (each increase draws one on every screen).
      // `noise` is free-form in the database rules, so none of this needs a rules change.
      case 'SET_NOISE':
        {
          var n = _objectSpread({}, state.noise || {});
          var _p = action.payload || {};
          ['interference', 'movement', 'leadoff', 'tremor'].forEach(function (k) {
            if (_p[k] !== undefined) n[k] = !!_p[k];
          });
          var STYLES = {
            pleth: ['normal', 'poor', 'motion', 'swing'],
            art: ['normal', 'overdamped', 'underdamped', 'swing']
          };
          Object.keys(STYLES).forEach(function (k) {
            if (_p[k] !== undefined) n[k] = STYLES[k].indexOf(_p[k]) !== -1 ? _p[k] : 'normal';
          });
          if (_p.artFlush) n.artFlush = (Number(n.artFlush) || 0) + 1;
          return _objectSpread(_objectSpread({}, state), {}, {
            noise: n
          });
        }
      // The defib and the ventilator share the room monitor's screen: opening one closes the other.
      // The defib and the ventilator are brought into the room independently; each patient
      // screen decides what it shows (data/simscreens.js).
      // Bringing a device in also puts it in front (the patient screens already do that), so
      // the controller's "Patient screens show" switch reflects it.
      case 'SET_DEFIB_PANEL':
        return _objectSpread(_objectSpread({}, state), {}, {
          defibPanelOpen: !!action.payload
        }, action.payload && !state.defibPanelOpen ? {
          screenFront: {
            view: 'defib',
            at: Date.now()
          }
        } : {});
      case 'SET_VENT_PANEL':
        return _objectSpread(_objectSpread({}, state), {}, {
          ventPanelOpen: !!action.payload
        }, action.payload && !state.ventPanelOpen ? {
          screenFront: {
            view: 'vent',
            at: Date.now()
          }
        } : {});
      // Put the monitor, the defib or the ventilator in front on every patient screen that has it.
      case 'SET_SCREEN_FRONT':
        return ['monitor', 'defib', 'vent'].includes(action.payload) ? _objectSpread(_objectSpread({}, state), {}, {
          screenFront: {
            view: action.payload,
            at: Date.now()
          }
        }) : state;
      // A patient screen's own role and what it is showing (never synced; read by presence).
      case 'SET_LOCAL_SCREEN':
        return _objectSpread(_objectSpread({}, state), {}, {
          localScreen: action.payload || null
        });
      // The ventilator's lungs: a known profile, whether the patient breathes for themselves
      // (true / false; null = as the profile says), the facilitator's lung adjustments
      // (lung: {c, r, m, o, e}; a key set to null goes back to the profile's value; lung: null
      // resets them all), the injected problems (probs: a list of ids) and the Assessment switch.
      // Anything else is ignored. Until the facilitator picks a profile it is the scenario's.
      case 'SET_VENT_CONFIG':
        {
          var _p2 = action.payload || {};
          var VP = window.VENT_PROFILES;
          var cur = state.vent || {};
          var scen = action.currentState && action.currentState.scenario;
          var fallback = VP ? VP.profileForScenario(scen) : 'normal';
          var profile = _p2.profile !== undefined ? _p2.profile : cur.profile || fallback;
          var breathing = _p2.breathing !== undefined ? _p2.breathing : cur.breathing;
          var lung = _p2.lung === null ? {} : _objectSpread({}, cur.lung || {});
          if (_p2.lung && VP) Object.keys(_p2.lung).forEach(function (k) {
            var d = VP.LUNG_ADJ[k];
            if (!d) return;
            var v = _p2.lung[k];
            if (v === null || v === undefined) {
              delete lung[k];
              return;
            }
            var n = Number(v);
            if (Number.isFinite(n)) lung[k] = Math.min(d.max, Math.max(d.min, n));
          });
          // A new profile starts from its own lung.
          if (_p2.profile !== undefined && _p2.profile !== cur.profile && _p2.lung === undefined) lung = {};
          var probs = _p2.probs !== undefined ? VP ? VP.probList(_p2.probs) : [] : cur.probs || [];
          var assess = _p2.assess !== undefined ? _p2.assess === true : !!cur.assess;
          // Which machine the candidate has: the Transport ventilator, the ICU ventilator or the
          // Anaesthetic machine.
          var model = VP ? VP.modelOf(_p2.model !== undefined ? _p2.model : cur.model) : 't1';
          // What the circuit connects to, when the facilitator says so ('mask', 'sga' or 'tube');
          // null = worked out from the patient (data/engine-vent.js interfaceFor).
          var airway = _p2.airway !== undefined ? _p2.airway : cur.airway;
          // Simple mode: the ventilator screens show big buttons for the common modes instead of the machine.
          var simple = _p2.simple !== undefined ? _p2.simple === true : !!cur.simple;
          return _objectSpread(_objectSpread({}, state), {}, {
            vent: {
              profile: VP && VP.profiles[profile] ? profile : 'normal',
              breathing: breathing === true || breathing === false ? breathing : null,
              lung: lung,
              probs: probs,
              assess: assess,
              model: model,
              simple: simple,
              airway: ['mask', 'sga', 'tube'].indexOf(airway) !== -1 ? airway : null
            }
          });
        }
      case 'SET_VENT_MIRROR':
        return _objectSpread(_objectSpread({}, state), {}, {
          ventMirror: action.payload || {}
        });
      case 'ADD_VENT_SAMPLE':
        return action.payload ? _objectSpread(_objectSpread({}, state), {}, {
          ventSamples: [].concat(_toConsumableArray(state.ventSamples || []), [action.payload]).slice(-480)
        }) : state;
      case 'SET_VENT_LINK':
        return _objectSpread(_objectSpread({}, state), {}, {
          ventLink: action.payload !== false
        });
      case 'SET_DEFIB_SETTINGS':
        return _objectSpread(_objectSpread({}, state), {}, {
          defibSettings: cleanDefibSettings(state.defibSettings, action.payload)
        });
      case 'SET_PACING_THRESHOLD':
        return _objectSpread(_objectSpread({}, state), {}, {
          pacingThreshold: Math.max(10, Math.min(140, Math.round(Number(action.payload) || state.pacingThreshold)))
        });
      case 'SET_PACING':
        return _objectSpread(_objectSpread({}, state), {}, {
          pacing: _objectSpread(_objectSpread({}, state.pacing), action.payload || {})
        });
      case 'SET_METRONOME':
        return _objectSpread(_objectSpread({}, state), {}, {
          metronomeOn: !!action.payload
        });
      case 'SET_DEVICE_MIRROR':
        return _objectSpread(_objectSpread({}, state), {}, {
          deviceMirror: action.payload || {}
        });
      case 'SET_REMOTE_PRESENCE':
        return _objectSpread(_objectSpread({}, state), {}, {
          remotePresence: {
            clients: action.payload || [],
            updatedAt: Date.now()
          }
        });
      case 'START_NIBP':
        return _objectSpread(_objectSpread({}, state), {}, {
          nibp: _objectSpread(_objectSpread({}, state.nibp), {}, {
            inflating: true
          })
        });
      // Quick Sim's own auto-cycle countdown (TICK_TIME does this while the clock runs).
      // Quick Sim before START: the record-only clock. It advances the debrief timeline and
      // the auto-NIBP countdown, and nothing else (no physiology, drugs or deterioration).
      case 'TICK_RECORD':
        return _objectSpread(_objectSpread({}, state), {}, {
          sessionTime: (Number(state.sessionTime) || 0) + 1,
          nibp: state.nibp.mode === 'auto' ? _objectSpread(_objectSpread({}, state.nibp), {}, {
            timer: state.nibp.timer - 1
          }) : state.nibp
        });
      // Abandons a measurement in progress: no reading is committed (the commit timer is
      // cleared by the effect that owns it as soon as `inflating` goes false).
      case 'STOP_NIBP':
        return _objectSpread(_objectSpread({}, state), {}, {
          nibp: _objectSpread(_objectSpread({}, state.nibp), {}, {
            inflating: false
          })
        });
      case 'COMMIT_NIBP':
        var safeSys = cs && cs.vitals.bpSys ? cs.vitals.bpSys : 0;
        var safeDia = cs && cs.vitals.bpDia ? cs.vitals.bpDia : 0;
        var now = new Date();
        var timeStr = "".concat(now.getHours().toString().padStart(2, '0'), ":").concat(now.getMinutes().toString().padStart(2, '0'));
        var newEntry = {
          sys: safeSys,
          dia: safeDia,
          time: timeStr
        };
        var newHistoryArr = [newEntry].concat(_toConsumableArray(state.nibp.history || [])).slice(0, 3);
        return _objectSpread(_objectSpread({}, state), {}, {
          nibp: _objectSpread(_objectSpread({}, state.nibp), {}, {
            sys: safeSys,
            dia: safeDia,
            lastTaken: Date.now(),
            timer: state.nibp.interval,
            inflating: false,
            history: newHistoryArr
          })
        });
      case 'TOGGLE_NIBP_MODE':
        var newMode = state.nibp.mode === 'manual' ? 'auto' : 'manual';
        return _objectSpread(_objectSpread({}, state), {}, {
          nibp: _objectSpread(_objectSpread({}, state.nibp), {}, {
            mode: newMode,
            timer: newMode === 'auto' ? state.nibp.interval : 0
          })
        });
      case 'SET_NIBP':
        return _objectSpread(_objectSpread({}, state), {}, {
          nibp: _objectSpread(_objectSpread({}, state.nibp), {}, {
            sys: action.payload.sys,
            dia: action.payload.dia,
            lastTaken: Date.now(),
            inflating: false
          })
        });
      case 'TRIGGER_SPEAK':
        return _objectSpread(_objectSpread({}, state), {}, {
          speech: {
            text: action.payload,
            clip: action.clip || null,
            timestamp: Date.now(),
            source: 'controller'
          }
        });
      case 'TRIGGER_SOUND':
        return _objectSpread(_objectSpread({}, state), {}, {
          soundEffect: {
            type: action.payload,
            timestamp: Date.now()
          }
        });
      case 'SET_AUDIO_OUTPUT':
        return _objectSpread(_objectSpread({}, state), {}, {
          audioOutput: action.payload
        });
      case 'LIVE_CLEARED':
        return state.liveSeen ? _objectSpread(_objectSpread({}, state), {}, {
          liveSeen: false
        }) : state;
      case 'SYNC_FROM_MASTER':
        return _objectSpread(_objectSpread({}, state), {}, {
          liveSeen: true,
          // isRunning / isMuted / activeLoops are what make the STUDENT MONITOR audible: every
          // audio path in this file is gated on isRunning, which the monitor can only learn
          // about over the wire because it never calls start() itself.
          isRunning: !!action.payload.isRunning,
          // Whether the pulse tone and alarms should sound, decided once on the controller
          // (see isAudioLive). Older controllers do not send it; isAudioLive falls back.
          audioLive: action.payload.audioLive === undefined ? undefined : !!action.payload.audioLive,
          isMuted: !!action.payload.isMuted,
          activeLoops: action.payload.activeLoops || {},
          isParalysed: !!action.payload.isParalysed,
          potassium: Number.isFinite(action.payload.potassium) ? action.payload.potassium : state.potassium,
          activeDrugs: Array.isArray(action.payload.activeDrugs) ? action.payload.activeDrugs : [],
          deteriorationMode: action.payload.deteriorationMode === 'auto' ? 'auto' : 'manual',
          rhythm: action.payload.rhythm,
          cprInProgress: action.payload.cprInProgress,
          etco2Enabled: action.payload.etco2Enabled,
          etco2Pathology: action.payload.co2Pathology || 'normal',
          co2Severity: Number.isFinite(action.payload.co2Severity) ? action.payload.co2Severity : 0,
          flash: action.payload.flash,
          cycleTimer: action.payload.cycleTimer,
          activeInterventions: new Set(action.payload.activeInterventions || []),
          nibp: action.payload.nibp || state.nibp,
          speech: action.payload.speech || state.speech,
          soundEffect: action.payload.soundEffect || state.soundEffect,
          audioOutput: action.payload.audioOutput || 'monitor',
          arrestPanelOpen: action.payload.arrestPanelOpen !== undefined ? action.payload.arrestPanelOpen : state.arrestPanelOpen,
          defibPanelOpen: !!action.payload.defibPanelOpen,
          ventPanelOpen: !!action.payload.ventPanelOpen,
          defib: _objectSpread(_objectSpread(_objectSpread({}, state.defib), action.payload.defib || {}), {}, {
            // The database drops a null, so a new run's "no request" never arrived and an old
            // Monitor/Defib/Ventilator request was applied again after the screen remounted.
            screenFront: action.payload.defib && action.payload.defib.screenFront || null
          }),
          isFinished: action.payload.isFinished || false,
          monitorPopup: action.payload.monitorPopup || state.monitorPopup,
          waveformGain: action.payload.waveformGain || 1.0,
          noise: action.payload.noise || {
            interference: false
          },
          notification: action.payload.notification || null,
          remotePacerState: action.payload.remotePacerState || {
            rate: 0,
            output: 0
          },
          pacingThreshold: action.payload.pacingThreshold || 70,
          lastUpdate: Date.now(),
          showWetflag: action.payload.showWetflag === true,
          monitorTimer: action.payload.monitorTimer || state.monitorTimer,
          pocReadings: action.payload.pocReadings || state.pocReadings || {}
        });
      case 'UPDATE_ASSESSMENT':
        return _objectSpread(_objectSpread({}, state), {}, {
          assessments: action.payload
        });
      case 'SET_FLASH':
        return _objectSpread(_objectSpread({}, state), {}, {
          flash: action.payload
        });
      case 'START_INTERVENTION_TIMER':
        return _objectSpread(_objectSpread({}, state), {}, {
          activeDurations: _objectSpread(_objectSpread({}, state.activeDurations), {}, _defineProperty({}, action.payload.key, {
            startTime: state.time,
            duration: action.payload.duration
          }))
        });
      // --- PK envelope bookkeeping -------------------------------------------------------
      case 'ADD_ACTIVE_DRUG':
        {
          if (!action.payload) return state;
          // Re-starting a continuous infusion that is still decaying: revive that entry rather
          // than stacking a second one, so stopping and restarting a pressor is not a dose.
          var existing = (state.activeDrugs || []).findIndex(function (d) {
            return d.key === action.payload.key && d.sustained && d.stopTime >= 0;
          });
          if (existing !== -1 && action.payload.sustained) {
            var revived = state.activeDrugs.slice();
            revived[existing] = _objectSpread(_objectSpread({}, revived[existing]), {}, {
              stopTime: -1
            });
            return _objectSpread(_objectSpread({}, state), {}, {
              activeDrugs: revived
            });
          }
          var _a = state.arrest || initialCoreState.arrest;
          var arrestKey = action.payload.key === 'AdrenalineIV' ? 'adrenaline' : action.payload.key === 'Amiodarone' ? 'amiodarone' : null;
          var _arrestAfter = arrestKey && _a.since !== null ? _objectSpread(_objectSpread({}, _a), {}, _defineProperty({}, arrestKey, [].concat(_toConsumableArray(_a[arrestKey]), [Number(state.time) || 0]))) : _a;
          return _objectSpread(_objectSpread({}, state), {}, {
            activeDrugs: [].concat(_toConsumableArray(state.activeDrugs || []), [action.payload]),
            arrest: _arrestAfter
          });
        }
      // TITRATABLE INFUSIONS. A running infusion was locked to the magnitude it
      // was started at, so noradrenaline, GTN, adrenaline, labetalol and insulin could only be
      // ON or OFF - titration to effect, the whole teaching point of a vasoactive infusion, was
      // impossible. `dose` is already the multiplier the envelope is scaled by, so the rate
      // change is a single field edit and the next tick composes it (no new entry, no reset of
      // the pk clock, nothing double-counted). Bounded 0.25x - 3x; permissive, never blocking.
      case 'SET_DRUG_DOSE':
        {
          var _ref = action.payload || {},
            _key = _ref.key,
            dose = _ref.dose;
          if (!_key || !Number.isFinite(Number(dose))) return state;
          var next = Math.max(0.25, Math.min(3, Number(dose)));
          var changed = false;
          var drugs = (state.activeDrugs || []).map(function (d) {
            if (d.key !== _key || !d.sustained || d.stopTime >= 0) return d;
            changed = true;
            return _objectSpread(_objectSpread({}, d), {}, {
              dose: next
            });
          });
          return changed ? _objectSpread(_objectSpread({}, state), {}, {
            activeDrugs: drugs
          }) : state;
        }
      case 'STOP_ACTIVE_DRUG':
        {
          // A continuous intervention was switched off: start its offset tail from now.
          var _changed = false;
          var _next = (state.activeDrugs || []).map(function (d) {
            if (d.key === action.payload && d.sustained && d.stopTime < 0) {
              _changed = true;
              return _objectSpread(_objectSpread({}, d), {}, {
                stopTime: state.time
              });
            }
            return d;
          });
          return _changed ? _objectSpread(_objectSpread({}, state), {}, {
            activeDrugs: _next
          }) : state;
        }
      case 'REVERSE_PARALYSIS_DRUGS':
        {
          var _changed2 = false;
          var _next2 = (state.activeDrugs || []).map(function (d) {
            if (d.paralytic && !d.reversed) {
              _changed2 = true;
              return _objectSpread(_objectSpread({}, d), {}, {
                reversed: true,
                paralysisEnd: Math.max(1, state.time - d.startTime)
              });
            }
            return d;
          });
          if (!_changed2) return state;
          return _objectSpread(_objectSpread({}, state), {}, {
            activeDrugs: _next2,
            isParalysed: false,
            paralysis: {
              active: false,
              agent: null,
              startTime: 0,
              onset: 0,
              duration: 0
            }
          });
        }
      case 'SET_DETERIORATION_MODE':
        return _objectSpread(_objectSpread({}, state), {}, {
          deteriorationMode: action.payload === 'auto' ? 'auto' : 'manual'
        });
      // =================================================================================
      // WAVE 9 / ROOT FIX — THIS ACTION IS A DELTA, NOT A WHOLE-SET REPLACEMENT.
      //
      // It used to carry `{ active: <a whole new Set>, counts: <a whole new object> }`, both
      // built by applyIntervention from `stateRef.current`. stateRef only catches up in an
      // effect AFTER a commit, so TWO applyIntervention calls in the SAME tick (React 18
      // batches them into one commit) each computed their replacement set from the same
      // pre-batch snapshot, and the second dispatch silently threw away the first one's
      // addition. That is exactly how "+ INVASIVE" attached the arterial line and lost IV
      // access while still logging both. It also lost interventionCounts for every drug but
      // the last when two drugs were given in one tick.
      //
      // A delta is immune: every dispatch in the batch is folded through the reducer in
      // order, each one seeing the accumulated `state`, so nothing can be overwritten.
      // The legacy whole-set payload is still honoured for any external/older caller.
      // =================================================================================
      case 'UPDATE_INTERVENTION_STATE':
        {
          var _p3 = action.payload || {};
          var isDelta = Array.isArray(_p3.add) || Array.isArray(_p3.remove) || Array.isArray(_p3.inc);
          if (!isDelta) return _objectSpread(_objectSpread({}, state), {}, {
            activeInterventions: _p3.active,
            interventionCounts: _p3.counts
          });
          var nextActive = new Set(state.activeInterventions);
          (_p3.add || []).forEach(function (k) {
            return nextActive.add(k);
          });
          (_p3.remove || []).forEach(function (k) {
            return nextActive["delete"](k);
          });
          var nextCounts = _objectSpread({}, state.interventionCounts);
          (_p3.inc || []).forEach(function (k) {
            nextCounts[k] = (nextCounts[k] || 0) + 1;
          });
          return _objectSpread(_objectSpread({}, state), {}, {
            activeInterventions: nextActive,
            interventionCounts: nextCounts
          });
        }
      // =================================================================================
      // ATOMIC BATCH ATTACH. One press = ONE reducer action, however many sensors
      // it puts on. The controller's "+ Invasive" and "Attach standard" buttons, the
      // PROCEDURES monitoring cards and the individual chips all come through here, so no
      // attach path can ever again lose a sensor to batching.
      //
      // Capnography is part of the same action rather than a separate TOGGLE_ETCO2 dispatch,
      // and it is SET rather than toggled — pressing "+ Invasive" twice in one tick can no
      // longer turn the capnograph back off.
      // =================================================================================
      case 'ATTACH_SENSORS':
        {
          var _p4 = action.payload && _typeof(action.payload) === 'object' && !Array.isArray(action.payload) ? action.payload : {
            keys: action.payload
          };
          var keys = (Array.isArray(_p4.keys) ? _p4.keys : _p4.keys ? [_p4.keys] : []).filter(function (k) {
            return k && k !== 'ToggleETCO2';
          });
          var _next3 = new Set(state.activeInterventions);
          keys.forEach(function (k) {
            return _next3.add(k);
          });
          // Durations are started in the same action, so the PROCEDURES card countdown cannot
          // disagree with the chip either.
          var durs = _objectSpread({}, state.activeDurations);
          keys.forEach(function (k) {
            var d = INTERVENTIONS[k] && INTERVENTIONS[k].duration;
            if (d && !durs[k]) durs[k] = {
              startTime: state.time,
              duration: d
            };
          });
          var etco2 = _p4.etco2 === undefined ? state.etco2Enabled : !!_p4.etco2;
          return _objectSpread(_objectSpread({}, state), {}, {
            activeInterventions: _next3,
            activeDurations: durs,
            etco2Enabled: etco2
          });
        }
      case 'REMOVE_INTERVENTION':
        {
          var removedActive = new Set(state.activeInterventions);
          removedActive["delete"](action.payload);
          var removedDurations = _objectSpread({}, state.activeDurations);
          delete removedDurations[action.payload];
          // Stopping an infusion/device starts its offset tail rather than deleting the effect.
          var stopped = (state.activeDrugs || []).map(function (d) {
            return d.key === action.payload && d.sustained && d.stopTime < 0 ? _objectSpread(_objectSpread({}, d), {}, {
              stopTime: state.time
            }) : d;
          });
          return _objectSpread(_objectSpread({}, state), {}, {
            activeInterventions: removedActive,
            activeDurations: removedDurations,
            activeDrugs: stopped
          });
        }
      // DETACHING ONE SENSOR.
      // 'Obs' is a SHORTHAND for the four standard sensors, which is why a second press on an
      // "attached" chip previously appeared to do nothing: the chip read as on (via 'Obs') but
      // its own key was not in the set, so the press ATTACHED the individual key and changed
      // nothing visible. Detaching therefore has to expand the shorthand first: 'Obs' is
      // replaced by the individual keys for the sensors that STAY, and only the requested one
      // comes off. The chips and the PROCEDURES cards both read getSensors(), so they cannot
      // get out of sync, and exactly one channel goes dark on the student monitor.
      // ONE implementation, taking a LIST. 'DETACH_SENSOR' (one key) is now literally
      // 'DETACH_SENSORS' with a single-element list, so a batch detach expands the 'Obs'
      // shorthand exactly once for the whole batch and cannot lose a removal to batching
      // either — the previous code path was only safe because it happened to be dispatched
      // one key at a time.
      case 'DETACH_SENSOR':
      case 'DETACH_SENSORS':
        {
          var _p5 = action.payload && _typeof(action.payload) === 'object' && !Array.isArray(action.payload) ? action.payload : {
            keys: action.payload
          };
          var raw = Array.isArray(_p5.keys) ? _p5.keys : _p5.keys ? [_p5.keys] : [];
          var dkeys = raw.filter(function (k) {
            return !!k;
          });
          var _next4 = new Set(state.activeInterventions);
          var dDurations = _objectSpread({}, state.activeDurations);
          var wantsEtco2Off = dkeys.indexOf('ToggleETCO2') !== -1;
          // Expand the 'Obs' shorthand ONCE, for the whole batch: every standard sensor that
          // is NOT being detached is re-added as its own key, then every requested key goes.
          var detachingObs = dkeys.indexOf('Obs') !== -1;
          var touchesStandard = detachingObs || dkeys.some(function (k) {
            return STANDARD_SENSOR_KEYS.indexOf(k) !== -1;
          });
          if (touchesStandard && _next4.has('Obs')) {
            _next4["delete"]('Obs');
            delete dDurations['Obs'];
            if (!detachingObs) STANDARD_SENSOR_KEYS.forEach(function (k) {
              if (dkeys.indexOf(k) === -1) _next4.add(k);
            });
          }
          dkeys.forEach(function (dkey) {
            if (dkey === 'Obs') {
              _next4["delete"]('Obs');
              STANDARD_SENSOR_KEYS.forEach(function (k) {
                _next4["delete"](k);
                delete dDurations[k];
              });
            } else {
              _next4["delete"](dkey);
            }
            delete dDurations[dkey];
          });
          var dStopped = (state.activeDrugs || []).map(function (d) {
            return dkeys.indexOf(d.key) !== -1 && d.sustained && d.stopTime < 0 ? _objectSpread(_objectSpread({}, d), {}, {
              stopTime: state.time
            }) : d;
          });
          return _objectSpread(_objectSpread({}, state), {}, {
            activeInterventions: _next4,
            activeDurations: dDurations,
            activeDrugs: dStopped,
            etco2Enabled: wantsEtco2Off ? false : state.etco2Enabled
          });
        }
      case 'DECREMENT_INTERVENTION':
        var decKey = action.payload;
        var decCounts = _objectSpread({}, state.interventionCounts);
        if (decCounts[decKey] > 0) decCounts[decKey]--;
        return _objectSpread(_objectSpread({}, state), {}, {
          interventionCounts: decCounts
        });
      case 'SET_PARALYSIS':
        {
          // Accepts either a bare boolean (legacy) or { active, agent, onset, duration }.
          var _p6 = action.payload;
          if (typeof _p6 === 'boolean') {
            return _objectSpread(_objectSpread({}, state), {}, {
              isParalysed: _p6,
              paralysis: _p6 ? _objectSpread(_objectSpread({}, state.paralysis), {}, {
                active: true
              }) : {
                active: false,
                agent: null,
                startTime: 0,
                onset: 0,
                duration: 0
              }
            });
          }
          if (!_p6 || _p6.active === false) {
            return _objectSpread(_objectSpread({}, state), {}, {
              isParalysed: false,
              paralysis: {
                active: false,
                agent: null,
                startTime: 0,
                onset: 0,
                duration: 0
              }
            });
          }
          return _objectSpread(_objectSpread({}, state), {}, {
            isParalysed: true,
            paralysis: {
              active: true,
              agent: _p6.agent || null,
              startTime: _p6.startTime !== undefined ? _p6.startTime : state.time,
              onset: _p6.onset || 0,
              duration: _p6.duration || 0
            }
          });
        }
      case 'TRIGGER_POPUP':
        {
          var _p7 = action.payload && _typeof(action.payload) === 'object' ? action.payload : {
            type: action.payload,
            customText: action.customText || null
          };
          return _objectSpread(_objectSpread({}, state), {}, {
            monitorPopup: {
              type: _p7.type,
              timestamp: Date.now(),
              customText: _p7.customText !== undefined ? _p7.customText : null,
              image: typeof _p7.image === 'string' ? _p7.image : null,
              hideReport: !!_p7.hideReport,
              // The controller's Normal button: the monitor shows a normal result with its picture
              normal: !!_p7.normal,
              // The patient picture shown on the monitor (data/screens/patientstatus.js showPicture)
              picture: _p7.picture && _typeof(_p7.picture) === 'object' ? _p7.picture : null
            }
          });
        }
      case 'CLEAR_POPUP':
        return _objectSpread(_objectSpread({}, state), {}, {
          monitorPopup: {
            type: null,
            timestamp: Date.now(),
            customText: null
          }
        });
      case 'SET_MUTED':
        return _objectSpread(_objectSpread({}, state), {}, {
          isMuted: action.payload
        });
      case 'SET_VOLUME':
        {
          var v = Number(action.payload);
          return Number.isFinite(v) ? _objectSpread(_objectSpread({}, state), {}, {
            volume: Math.max(0, Math.min(1.5, v))
          }) : state;
        }
      case 'TOGGLE_ETCO2':
        return _objectSpread(_objectSpread({}, state), {}, {
          etco2Enabled: !state.etco2Enabled
        });
      case 'SET_ETCO2_PATHOLOGY':
        return _objectSpread(_objectSpread({}, state), {}, {
          etco2Pathology: action.payload
        });
      // A point-of-care check. Records the value AT THIS MOMENT with both a
      // sim-clock offset and a wall-clock stamp, so the monitor can render it as a reading
      // ("GLUCOSE 4.1 @ 09:47") rather than a live channel.
      case 'RECORD_POC':
        {
          var _p8 = action.payload || {};
          if (!_p8.key) return state;
          var entry = {
            at: Number.isFinite(_p8.at) ? _p8.at : state.time,
            clock: _p8.clock || new Date().toLocaleTimeString('en-GB', {
              hour: '2-digit',
              minute: '2-digit'
            }),
            value: Number.isFinite(_p8.value) ? _p8.value : null,
            value2: Number.isFinite(_p8.value2) ? _p8.value2 : null
          };
          return _objectSpread(_objectSpread({}, state), {}, {
            pocReadings: _objectSpread(_objectSpread({}, state.pocReadings || {}), {}, _defineProperty({}, _p8.key, entry))
          });
        }
      case 'TOGGLE_CPR':
        return _objectSpread(_objectSpread({}, state), {}, {
          cprInProgress: action.payload
        });
      case 'SET_QUEUED_RHYTHM':
        return _objectSpread(_objectSpread({}, state), {}, {
          queuedRhythm: action.payload
        });
      case 'FAST_FORWARD':
        return _objectSpread(_objectSpread({}, state), {}, {
          time: state.time + action.payload,
          sessionTime: (Number(state.sessionTime) || 0) + action.payload
        });
      // The `processedEvents` / MARK_EVENT_PROCESSED machinery is GONE. It existed
      // to de-duplicate timed scenario events, but no scenario in the library has ever carried
      // an `events` or `timeline` array, nothing ever dispatched MARK_EVENT_PROCESSED, and the
      // Set was being serialised into every localStorage snapshot for nothing. Autonomous
      // progression is handled by the Wave 3/4a deterioration model instead. If timed scripted
      // events are ever wanted, build them on `scenario.deterioration`'s rate model rather than
      // resurrecting this.
      case 'SET_ARREST_PANEL':
        return _objectSpread(_objectSpread({}, state), {}, {
          arrestPanelOpen: action.payload
        });
      case 'SET_GAIN':
        return _objectSpread(_objectSpread({}, state), {}, {
          waveformGain: action.payload
        });
      case 'TOGGLE_INTERFERENCE':
        return _objectSpread(_objectSpread({}, state), {}, {
          noise: _objectSpread(_objectSpread({}, state.noise), {}, {
            interference: !state.noise.interference
          })
        });
      case 'UPDATE_PACER_STATE':
        return _objectSpread(_objectSpread({}, state), {}, {
          remotePacerState: action.payload
        });
      case 'SET_NOTIFICATION':
        return _objectSpread(_objectSpread({}, state), {}, {
          notification: action.payload
        });
      case 'UPDATE_AUDIO_LOOPS':
        return _objectSpread(_objectSpread({}, state), {}, {
          activeLoops: action.payload
        });
      case 'COMPLETE_OBJECTIVE':
        var newObjs = new Set(state.completedObjectives);
        newObjs.add(action.payload);
        return _objectSpread(_objectSpread({}, state), {}, {
          completedObjectives: newObjs
        });
      // The facilitator's own tick in the debrief, for an objective that cannot be scored from
      // what was given (recognition, judgement, communication). Pressing it again removes it.
      case 'TOGGLE_OBJECTIVE':
        {
          var objs = new Set(state.completedObjectives);
          if (objs.has(action.payload)) objs["delete"](action.payload);else objs.add(action.payload);
          return _objectSpread(_objectSpread({}, state), {}, {
            completedObjectives: objs
          });
        }
      case 'SET_WETFLAG_VISIBILITY':
        return _objectSpread(_objectSpread({}, state), {}, {
          showWetflag: action.payload
        });
      default:
        return state;
    }
  };

  // Test hook. The reducers are the physiology, so the Node verification harness reduces the REAL
  // ones rather than a reimplementation — that is the only way the composition and no-discontinuity
  // guarantees are actually proven rather than asserted about a copy.
  window.__pkInternals.reducers = {
    vitalsReducer: vitalsReducer,
    coreReducer: coreReducer,
    logReducer: logReducer,
    scenarioReducer: scenarioReducer,
    initialVitalsState: initialVitalsState,
    initialCoreState: initialCoreState,
    initialLogState: initialLogState,
    initialScenarioState: initialScenarioState
  };
  // The Firebase payload contract is verified too, so the sanitiser has to be reachable.
  window.__pkInternals.sanitizeForRealtimeDatabase = sanitizeForRealtimeDatabase;
  window.__EngineReducers = {
    coreReducer: coreReducer,
    logReducer: logReducer,
    scenarioReducer: scenarioReducer,
    vitalsReducer: vitalsReducer
  };
})();